<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="showModal"
      width="500"
      header
      footer
      @ok="() => showModal = false"
    >
      <div class="primary-background claim-modal-header">
        <div class="secondary-background profile-img"></div>
      </div>
      <div
        class="profile-details text-center"
        v-if="selectedDoctorProfile"
      >
        <h3>Dr. {{ selectedDoctorProfile.first_name }} {{ selectedDoctorProfile.last_name }}</h3>
        <p class="font-light">{{ csvArray(selectedDoctorProfile.areas_of_practice) }}</p>
        <p class="m-0">NPI NUMBER</p>
        <h5>{{ selectedDoctorProfile.id }}</h5>
        <p class="mt-4">We successfully found your profile on DoveMed. Please claim your profile in order to continue.</p>

        <div class="terms-policy-section text-left mt-5">
          <p class="m-0">
            <a-radio :size="'large'">The information is correct.</a-radio>
          </p>
          <p>
            <a-radio :size="'large'">I agree to the <u>Perjury Statement.</u></a-radio>
          </p>
        </div>
        <div class="claim-button mt-5">
          <button
            class='dovemed-button primary-button full-width-input font-white'
            :style="{background: getPrimaryColor()}"
            @click="() => {$refs.ClaimProfileTY.show();this.hide()}"
          >CLAIM PROFILE</button>
        </div>
        <div class="disclaimer my-5">
          <p>See something wrong? <span class="hyper-link">Report now!</span></p>
        </div>
      </div>
    </a-modal>
    <ClaimProfileTY ref="ClaimProfileTY" />
  </div>
</template>

<script>
import ClaimProfileTY from './ClaimProfileTY'

export default {
  name: 'ClaimProfileModal',
  components: {
    ClaimProfileTY
  },
  data () {
    return {
      showModal: false,
      selectedDoctorProfile: undefined
    }
  },
  methods: {
    show (data) {
      this.showModal = true
      this.selectedDoctorProfile = data
    },
    hide () {
      this.showModal = false
    },
    csvArray (arr) {
      return arr.join(', ')
    },
    showThankYou () {
      this.$refs.ClaimProfileTY.show()
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Modals/ClaimProfile.vue